<template>
  <span
    v-if="latency"
    class="inline-flex items-center gap-1 text-xs text-mouse"
  >
    <span
      class="inline-block h-2 w-2 shrink-0 rounded-full"
      :class="dotClass"
    ></span>
    {{ latency }}ms
  </span>
</template>

<script lang="ts">
export default defineComponent({
  name: 'LatencyResult',
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const locationStore = useLocationStore();
    const latency = computed<number | undefined>(() => {
      const result = locationStore.latencyMeasurements.find(
        (l: LatencyMeasurement) => l.slug === props.slug,
      );

      if (result) {
        return result.latency;
      }

      return undefined;
    });

    const dotClass = computed<string>(() => {
      if (!latency.value) return 'bg-mouse';
      if (latency.value > 150) return 'bg-danger';
      if (latency.value > 75) return 'bg-warning';
      return 'bg-success';
    });

    return {
      latency,
      dotClass,
    };
  },
});
</script>
